<template>
  <div style="padding: 20px;">
    <!-- tabs 栏 -->
    <!-- <div style="display: flex;justify-content: space-between">
      <div class="custom-tabs">
        <div
          v-for="(tab, index) in tabList"
          :key="index"
          :class="['tab-item', query.strategy_type === tab.value ? 'active' : '']"
          @click="changeTab(tab.value)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div style="color: #4E5969;">
        <el-button
          icon="el-icon-plus"
          type="success"
          @click="createStrategy"
        >新建策略</el-button>
      </div>
    </div>
    <div class="line" /> -->
    <div style="display: flex;height: 100%;">
      <!-- <div style="width: 300px;margin: 20px 20px 0 0;">
        <div
          class="search-container"
          style="display: flex; justify-content: center; align-items: center;"
        >
          <el-input
            v-model="query.keyword"
            placeholder="请输入名称"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearchrallr"
            />
          </el-input>
        </div>

        <div
          ref="tableContainer"
          style="width: 100%;height: 900px;overflow: auto;margin-top: 20px;cursor: pointer;"
          @scroll="handleTableScroll"
        >
          <el-table
            v-loading="loading"
            :data="table_data"
            border
            @cell-mouse-enter="handleCellMouseEnter"
            @row-click="handleRowClick"
          >
            <el-table-column label="策略名称">
              <template slot-scope="scope">
                <div style="display: flex; justify-content: space-between; align-items: center; gap: 8px;">
                  <div
                    style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                    :style="hoveredRowId === scope.row.id? 'color: #447DFF': ''"
                  >
                    {{ scope.row.strategy_name }}
                    <div>({{ scope.row.strategy_no }})</div>
                  </div>
                  <div
                    v-if="hoveredRowId === scope.row.id"
                    style="display: flex; gap: 8px; flex-shrink: 0;"
                  >
                    <el-button
                      type="text"
                      size="mini"
                      @click.stop="handleClick(scope.row)"
                    >
                      <img
                        src="@/assets/svg/edit.svg"
                        alt="编辑"
                        style="width: 20px; height: 20px;"
                      >
                    </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      @click.stop="handDelete(scope.row.id)"
                    >
                      <img
                        src="@/assets/svg/delete.svg"
                        alt="删除"
                        style="width: 20px; height: 20px;"
                      >
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div
        v-if="strategy_no"
        style="border-left: 1px solid #E5E6EB;padding: 20px 0 0 20px;width: 2550px"
      >
        <div style="width: 100%;height: 50px;border: 1px solid #F7F8FA;background-color: #F7F8FA;display: flex;justify-content: space-between;text-align: center;align-items: center;margin-bottom: 20px">
          <div style="align-items: center; white-space: nowrap;padding-left: 20px">
            短剧名称:<el-input
              v-model="qy_platy_let.playlet_name"
              placeholder="请输入名称"
              style="margin-left: 15px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="playLetSearch"
              />
            </el-input>
          </div>
          <div>
            <el-switch
              v-model="status"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="2"
              active-text="开启"
              inactive-text="关闭"
              :disabled="switch_loading"
              @change="switchChange"
            />
          </div>
          <div>
            <el-tag
              v-for="item,index in strategy_where_name"
              :key="index"
              style="margin-right: 5px"
            >{{ item }}</el-tag>
          </div>
        </div>
        <div
          v-loading="info_loading"
          style="display: flex;flex-wrap: wrap"
        >
          <div
            v-for="(tab, index) in table_info_data"
            :key="index"
            class="item_box"
            style="cursor: pointer;"
            @click="gotiwe(tab)"
          >
            <div class="item_box_head">
              <el-image
                class="el_img"
                fit="cover"
                :src="tab.cover_oss"
              />
            </div>
            <div class="item_box_body">
              <div class="item_bd_name">
                <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ tab.playlet_name }}</div>
              </div>
              <div class="item_bd_time">{{ tab.created_at }}</div>
            </div>
          </div>
          <div
            style="height: 306px;width: 224px;display: flex;align-items: center;justify-content: center;flex-direction: column;;text-align: center;border: 1px solid #EAEBEF;color: #86909C;background-color: #F7F8FA;border-radius: 4px;cursor: pointer;"
            @click="linkToInfo()"
          >
            <img
              src="@/assets/images/Frame.png"
              alt="alt"
              style="width: 60%"
            >
            <div> 更多素材</div>
          </div>
        </div>
        <pagination-right
          :total="table_total"
          :page-sizes="[30, 50, 100]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div> -->
    </div>
    <el-card style="margin-bottom: 20px">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div>
          <el-input v-model="query.strategy_no" placeholder="请输入策略编号" style="width: 200px;" />
          <el-select v-model="query.strategy_type" placeholder="请选择" style="margin: 0 20px;">
            <el-option
              v-for="item in tabList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select v-model="query.pull_status" placeholder="请选择" style="margin-right: 10px;">
            <el-option
              v-for="item in newlookoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            style="margin-right:10px"
            icon="el-icon-search"
            @click="sraw"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            @click="awered"
          >重置</el-button>
        </div>
        <div>
          <el-button
            icon="el-icon-plus"
            type="success"
            @click="createStrategy"
          >新建策略</el-button>
        </div>
      </div>
    </el-card>
    <el-card>
      <el-table
        v-loading="loading"
        :data="table_data"
        style="width: 100%"
      >
        <el-table-column
          prop="strategy_no"
          label="策略编号"
          width="200"
          align="center"
        />
        <el-table-column
          prop="strategy_name"
          label="策略名称"
          width="200"
          align="center"
        />
        <el-table-column
          prop="strategy_type_text"
          label="策略类型"
          width="200"
          align="center"
        />
        <el-table-column
          prop="search_play_name"
          label="短剧名称"
          width="200"
          align="center"
        />
        <el-table-column
          prop="page_size"
          label="拉取页数"
          width="100"
          align="center"
        />
        <el-table-column
          prop="pull_status"
          label="状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <i
              :class="getIconClass(scope.row.pull_status)"
              :style="{ color: getIconColor(scope.row.pull_status), marginRight: '6px', fontSize: '16px' }"
            />
            {{ scope.row.pull_status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="leader_name"
          label="创建人"
          align="center"
          width="200"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="200"
        />
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
        >
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              @click="lookdetail(scope.row)"
            >查看素材</el-button>
            <el-button
              v-if="scope.row.pull_status == 1 || scope.row.pull_status == 2"
              type="danger"
              size="mini"
              @click="stopr(scope.row)"
            >停止</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination-right
        ref="paginationbox"
        :total="newtotalr"
        :page-sizes="[10]"
        @size-change="fetchPageSizermr($event)"
        @current-change="fetchCurrentPagermr"
      />
    </el-card>
    <el-dialog
      :visible.sync="add_visable"
      :title="id? '修改策略': '新增策略'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="734px"
    >
      <Details
        ref="dts"
        @close="closeDet"
        @logData="commit"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="look_visable"
      :title="look_title"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="1800px"
    >
      <div style="border: 1px solid #ccc;display: flex">
        <div style="width: 400px;padding:30px">
          <div v-if="allobj.material_type == 1">
            <el-image
              style="width: 100%; height: 100%;"
              fit="cover"
              :src="allobj.pic_list[0]"
            />
          </div>
          <div v-if="allobj.material_type == 2">
            <video
              width="100%"
              height="100%"
              controls
              :src="allobj.video_list[0]"
            >
              您的浏览器不支持 video 标签。
            </video>
          </div>
        </div>
        <div style="border: 1px solid #ccc;width: 1400px">
          <div style="padding: 30px">
            <el-input
              v-model="look_query.title"
              placeholder="请输入短剧名称"
              style="width: 250px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearchr"
              />
            </el-input>
            <el-select
              v-model="look_query.material_type"
              placeholder="请选择"
              style="margin-left: 20px"
            >
              <el-option
                v-for="item in look_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="success"
              plain
              style="float: right;margin-left: 10px"
              icon="el-icon-upload"
            >上传</el-button>
            <el-button
              type="info"
              plain
              style="float: right"
            >详情</el-button>
          </div>
          <div style="padding: 0 30px">
            <div style="display: flex;flex-wrap: wrap">
              <div
                v-for="(tab, index) in look_data.list"
                :key="index"
                class="item_box"
                @click="itwmnw(tab)"
              >
                <div class="item_box_head">
                  <el-image
                    class="el_img"
                    fit="cover"
                    :src="tab.material_type === 1? tab.pic_list[0] : tab.video_list[0]"
                  />
                </div>
                <div class="item_box_body">
                  <div class="item_bd_name">
                    <el-tag
                      v-if="tab.material_type === 1"
                      size="mini"
                    >图片</el-tag>
                    <el-tag
                      v-else
                      size="mini"
                      type="warning"
                    >视频</el-tag>
                    <div class="uiwei_name">{{ tab.title }}</div>
                    <div>id: {{ tab.material_id }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <pagination-right
            :total="look_data.total"
            :page-sizes="[10,20]"
            @size-change="fetchPageSizer"
            @current-change="fetchCurrentPager"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { materialInfoList, playLetList, strategyCreate, strategyDelete, strategyList, strategyStop, strategyUpdate } from '@/api/report/adx'
import Details from '@/views/adx/Materials/components/details.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight, Details },
  data() {
    return {
      tabList: [
        { label: '全部', value: 0 },
        { label: '常规短剧', value: 1 },
        { label: '新剧', value: 2 },
        { label: '爆款', value: 3 }
      ],
      query: {
        page: 1,
        pageSize: 10,
        strategy_type: 1,
        keyword: null,
        strategy_no: null,
        pull_status: 0
      },
      qy_platy_let: {
        page: 1,
        pageSize: 30,
        strategy_no: null,
        playlet_name: null
      },
      table_data: [],
      table_info_data: [],
      activeNames: [],
      hoveredRowId: null,
      info_loading: false,
      add_visable: false,
      id: null,
      total: 0,
      noMoreData: false,
      loading: false,
      strategy_no: null,
      strategy_where_name: [],
      status: null,
      switch_loading: false,
      look_visable: false,
      look_title: '',
      look_query: {
        page: 1,
        pageSize: 10,
        material_type: '',
        title: ''
      },
      look_options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '图片'
        },
        {
          value: 2,
          label: '视频'
        }
      ],
      look_material_type: null,
      look_data: [],
      table_total: null,
      allobj: {},
      newtotalr: null,
      newlookoptions: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '待开始'
        },
        {
          value: 2,
          label: '已经开始'
        },
        {
          value: 3,
          label: '拉取完成'
        },
        {
          value: 4,
          label: '强制停止'
        }
      ]
    }
  },
  created() {
    this.list()
    const row = JSON.parse(window.sessionStorage.getItem('row'))
    if (row) {
      this.handleRowClick(row)
      console.log(row, 2222)
    }
  },
  methods: {
    changeTab(val) {
      this.query.strategy_type = val
      this.query.page = 1
      // 这里你可以直接 this.getList(val)
      this.list()
      this.strategy_no = null
    },
    list() {
      this.loading = true
      strategyList(this.query).then(res => {
        console.log(res)
        this.table_data = res.data.list
        this.newtotalr = res.data.total
        this.loading = false
      })
    },
    createStrategy() {
      this.id = null
      this.add_visable = true
    },
    linkToInfo(val) {
      if (val) {
        this.$router.push({ path: '/adx/MaterialsInfo/index', query: { playlet_id: val.playlet_id }})
      } else {
        this.$router.push({ path: '/adx/MaterialsInfo/index', query: { strategy_no: this.strategy_no }})
      }
    },
    lookInfo(val) {
      console.log(val)
      this.look_visable = true
      this.look_query.playlet_id = val.playlet_id
      this.lookData('1')
    },
    lookData(type) {
      materialInfoList(this.look_query).then(res => {
        console.log(res)
        this.look_data = res.data
        // eslint-disable-next-line eqeqeq
        if (type == 1) {
          console.log('this.look_data.list', this.look_data)
          // eslint-disable-next-line eqeqeq
          if (this.look_data.list.length != 0) {
            this.allobj = this.look_data.list[0]
          } else {
            this.allobj = {}
          }
        }
      })
    },
    fetchPageSizer(data) {
      this.look_query.pageSize = data
      this.lookData()
    },
    // 抓取当前页数据
    fetchCurrentPager(data) {
      this.look_query.page = data
      this.lookData()
    },
    handleSearchr() {
      this.lookData()
    },
    clickCha(val) {
      console.log(22222222222222222222222)
    },
    handleSearch() {
      // 搜索处理
      console.log('搜索关键词:', this.query.keyword)
      this.query.page = 1
      this.noMoreData = false
      this.list()
    },
    playLetSearch() {
      // 搜索处理
      this.qy_platy_let.page = 1
      this.playLetList()
    },
    handleClick(val) {
      // 点击事件处理
      console.log(val)
      this.id = val.id
      this.add_visable = true
      this.$nextTick(function() {
        this.$refs.dts.send(val, 2)
      })
    },
    handDelete(id) {
      // 点击事件处理
      console.log(id)
      this.$confirm('确定要删除该策略吗', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        strategyDelete({ id: id }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.list()
          }
        })
      })
    },
    handleRowClick(row) {
      console.log(row)
      window.sessionStorage.setItem('row', JSON.stringify(row))
      if (row.strategy_no) {
        this.qy_platy_let.page = 1
        this.info_loading = true
        this.qy_platy_let.strategy_no = row.strategy_no
        this.id = row.id
        this.strategy_no = row.strategy_no
        this.status = row.status
        this.strategy_where_name = row.strategy_where_name
        this.playLetList()
      }
    },
    handleCellMouseEnter(row, column, cell, event) {
      this.hoveredRowId = row.id
    },
    closeDet() {
      this.add_visable = false
      this.id = null
    },
    commit(val, type) {
      // 统一的请求处理
      const request = this.id ? strategyUpdate({ ...val, id: this.id }) : strategyCreate(val)

      request
        .then(res => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message.success(this.id ? '修改成功' : '添加成功')
            this.add_visable = false
            this.id = null // 重置id
            this.list()
          }
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    playLetList() {
      playLetList(this.qy_platy_let).then(res => {
        console.log(res)
        this.table_info_data = res.data.list
        this.table_total = res.data.total
        this.info_loading = false
      })
    },
    fetchPageSize(data) {
      this.qy_platy_let.pageSize = data
      this.playLetList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.qy_platy_let.page = data
      this.playLetList()
    },
    handleTableScroll(event) {
      const tableContainer = event.target
      // 计算是否滚动到底部（距离底部50px时触发）
      const bottomDistance = tableContainer.scrollHeight - tableContainer.scrollTop - tableContainer.clientHeight
      if (bottomDistance < 50 && !this.loading) {
        this.loadMoreData()
      }
    },

    async loadMoreData() {
      if (this.loading || this.noMoreData) return
      this.loading = true
      console.log(33333)
      try {
        this.query.page++
        const res = await strategyList(this.query)
        if (res.data.list.length) {
          this.table_data = [...this.table_data, ...res.data.list]
        } else {
          this.$message.info('数据已经全部展示啦！')
          this.noMoreData = true // 没有更多数据了
        }
      } finally {
        this.loading = false
      }
    },
    async switchChange(val) {
      console.log(this.id, val)
      if (!this.id) return // 如果没有 id，直接返回

      this.switch_loading = true
      try {
        const res = await strategyStop({ id: this.id, status: val })
        if (res.code === 0) {
          this.$message.success('修改成功，请刷新页面')
        }
      } catch (error) {
        console.error('修改失败:', error)
        this.$message.error('修改失败，请重新点击策略')
      } finally {
        this.switch_loading = false
        // this.playLetList()
        this.list()
      }
    },
    handleCommand(command) {
      if (command.key === 'info') {
        this.linkToInfo(command.item)
      } else if (command.key === 'look') {
        this.lookInfo(command.item)
      } else if (command.key === 'cmit') {
        console.log('cmit')
      }
    },
    itwmnw(item) {
      console.log(item)
      this.allobj = item
    },
    handleSearchrallr() {
      this.list()
    },
    gotiwe(item) {
      this.linkToInfo(item)
    },
    getIconClass(status) {
      switch (status) {
        case 1:
          return 'el-icon-time' // 待拉取
        case 2:
          return 'el-icon-loading' // 拉取中（自带旋转动画）
        case 3:
          return 'el-icon-circle-check' // 拉取完成
        default:
          return 'el-icon-question' // 未知
      }
    },
    getIconColor(status) {
      switch (status) {
        case 1:
          return '#E6A23C' // 橙色
        case 2:
          return '#409EFF' // 蓝色
        case 3:
          return '#67C23A' // 绿色
        default:
          return '#909399' // 灰色
      }
    },
    sraw() {
      this.query.page = 1
      this.list()
    },
    awered() {
      this.query.page = 1
      this.query.strategy_type = 1
      this.query.strategy_no = ''
      this.query.pull_status = 0
      this.list()
    },
    // 分页
    fetchPageSizermr(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPagermr(e) {
      this.query.page = e
      this.list()
    },
    lookdetail(item) {
      this.$router.push({ name: 'ADXAccountList', params: { strategy_no: item.strategy_no }})
    },
    stopr(item) {
      this.$confirm('此操作将停止, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        strategyStop({
          id: item.id
        }).then((res) => {
          this.list()
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>

<style scoped>
.custom-tabs {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
}

.tab-item {
  margin-right: 30px;
  height: 50px;
  padding: 8px 0;
  cursor: pointer;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-item.active {
  color: #1677ff;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #1677ff;
  border-radius: 2px;
}

.line {
  height: 1px;
  background: #e5e6eb;
  margin-top: 1px;
}
.item_box {
  height: 306px;
  width: 224px;
  border: 1px solid #eaebef;
  border-radius: 4px;
  margin-right: 24px;
  margin-bottom: 20px;
  padding-top: 5px;
}
.item_box_head {
  height: 226px;
  width: 100%;
  background-color: #f7f8fa;
}
.el_img {
  width: 158px;
  height: 226px;
  margin-left: 32px;
}
.item_box_body {
  margin: 16px 20px;
  height: 48px;
  position: relative;
  background-color: #ffffff;
}
.item_bd_name {
  height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1d2129;
  font-size: 14px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}
.uiwei_name {
  max-width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 10px;
}
.item_bd_time {
  height: 18px;
  position: absolute;
  bottom: 0;
  width: 150px;
  color: #86909c;
  font-size: 12px;
}
.item_bd_det {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
